import { render, staticRenderFns } from "./PortfolioAnalytics.vue?vue&type=template&id=228ded27&scoped=true"
import script from "./PortfolioAnalytics.vue?vue&type=script&lang=js"
export * from "./PortfolioAnalytics.vue?vue&type=script&lang=js"
import style0 from "./PortfolioAnalytics.vue?vue&type=style&index=0&id=228ded27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228ded27",
  null
  
)

export default component.exports